import { CartModule } from '@/components/modules/Cart/Cart';
import { KYCOrderModule } from '@/components/modules/KYC/KYCOrder/KYCOrder';
import { OrderActivityModule } from '@/components/modules/OrderActivity/OrderActivity';
import { LoanPaymentAttemptsModule } from '@/components/modules/PaymentAttempts/Loan/LoanPaymentAttempts';
import { OrderDetailsOverviewModule } from '@/components/modules/ProductsDetailsOverview/OrderDetailsOverview';
import { OrderShippingAndBillingModule } from '@/components/modules/ShippingAndBilling/OrderShippingAndBilling';
import { ALL_CORE_APP_USER_TYPES, APP_USER_TYPES } from '@/config/config';

// import { Fraud } from '@/components/modules/Fraud/Fraud';

export const orderSections = [
  {
    textId: 'ORDER_OVERVIEW',
    module: (
      <OrderDetailsOverviewModule
        permissions={{
          view: ALL_CORE_APP_USER_TYPES,
        }}
      />
    ),
  },
  {
    textId: 'CART',
    module: (
      <CartModule
        permissions={{
          view: [
            APP_USER_TYPES.SUPER_ADMIN,
            APP_USER_TYPES.ADMIN,
            APP_USER_TYPES.MERCHANT_GROUP,
            APP_USER_TYPES.MERCHANT,
            APP_USER_TYPES.CHANNEL,
            APP_USER_TYPES.AGENT,
            // APP_USER_TYPES.PARTNER,
            APP_USER_TYPES.LENDER,
            APP_USER_TYPES.CPC_BACK_OFFICE,
            // APP_USER_TYPES.THIRD_PARTY_VALIDATION,
          ],
        }}
      />
    ),
  },
  {
    textId: 'PERSONAL_INFORMATION',
    module: (
      <KYCOrderModule
        permissions={{
          view: [
            APP_USER_TYPES.SUPER_ADMIN,
            APP_USER_TYPES.ADMIN,
            APP_USER_TYPES.MERCHANT_GROUP,
            // APP_USER_TYPES.MERCHANT,
            // APP_USER_TYPES.CHANNEL,
            // APP_USER_TYPES.AGENT,
            // APP_USER_TYPES.PARTNER,
            APP_USER_TYPES.LENDER,
            APP_USER_TYPES.CPC_BACK_OFFICE,
            // APP_USER_TYPES.THIRD_PARTY_VALIDATION,
          ],
        }}
      />
    ),
  },
  {
    textId: 'PAYMENT_ATTEMPTS',
    module: (
      <LoanPaymentAttemptsModule
        permissions={{
          view: [
            APP_USER_TYPES.SUPER_ADMIN,
            APP_USER_TYPES.ADMIN,
            APP_USER_TYPES.MERCHANT_GROUP,
            // APP_USER_TYPES.MERCHANT,
            // APP_USER_TYPES.CHANNEL,
            // APP_USER_TYPES.AGENT,
            APP_USER_TYPES.PARTNER,
            APP_USER_TYPES.LENDER,
            APP_USER_TYPES.CPC_BACK_OFFICE,
            // APP_USER_TYPES.THIRD_PARTY_VALIDATION,
          ],
        }}
      />
    ),
  },
  {
    textId: 'ORDER_ACTIVITY',
    module: (
      <OrderActivityModule
        permissions={{
          view: [...ALL_CORE_APP_USER_TYPES],
        }}
      />
    ),
  },
  {
    textId: 'SHIPPING_AND_BILLING',
    module: (
      <OrderShippingAndBillingModule
        permissions={{
          view: [...ALL_CORE_APP_USER_TYPES],
        }}
      />
    ),
  },
  // // {
  // //   textId: 'FRAUD',
  // //   schemesByRoles: [
  // //     {
  // //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MERCHANT, ROLES.CHANNEL, ROLES.LENDER],
  // //       modules: [<Fraud />],
  // //     },
  // //   ],
  // // },
];
